/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "web_services/candidate_experience/proto/user.proto" (package "applied.candidate_experience", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * NOTE: password_last_updated is used specifically in registration flow and
 * otherwise doesn't need to be sent.
 *
 * @generated from protobuf message applied.candidate_experience.Account
 */
export interface Account {
    /**
     * @generated from protobuf field: string resource_uuid = 1;
     */
    resourceUuid: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: string first_name = 3;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 4;
     */
    lastName: string;
    /**
     * @generated from protobuf field: string profile_image_url = 5;
     */
    profileImageUrl: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.Candidate
 */
export interface Candidate {
    /**
     * @generated from protobuf field: applied.candidate_experience.Account account_info = 1;
     */
    accountInfo?: Account;
    /**
     * @generated from protobuf field: string resource_uuid = 2;
     */
    resourceUuid: string;
    /**
     * @generated from protobuf field: string application_id = 3;
     */
    applicationId: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.Employee
 */
export interface Employee {
    /**
     * @generated from protobuf field: applied.candidate_experience.Account account_info = 1;
     */
    accountInfo?: Account;
    /**
     * @generated from protobuf field: string resource_uuid = 2;
     */
    resourceUuid: string;
    /**
     * @generated from protobuf field: string anaheim_uuid = 3;
     */
    anaheimUuid: string;
    /**
     * @generated from protobuf field: string linkedin_url = 4;
     */
    linkedinUrl: string;
}
/**
 * The protobuf format sent from Anaheim to candidate experience to sync
 * candidate info to the database.
 *
 * @generated from protobuf message applied.candidate_experience.CandidateSyncRequest
 */
export interface CandidateSyncRequest {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
    /**
     * @generated from protobuf field: string first_name = 2;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 3;
     */
    lastName: string;
    /**
     * @generated from protobuf field: string profile_image_filename = 4;
     */
    profileImageFilename: string;
    /**
     * @generated from protobuf field: string application_id = 5;
     */
    applicationId: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.CandidateSyncResponse
 */
export interface CandidateSyncResponse {
    /**
     * @generated from protobuf field: string registration_token = 1;
     */
    registrationToken: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.CheckCandidateExistsResponse
 */
export interface CheckCandidateExistsResponse {
    /**
     * @generated from protobuf field: bool exists = 1;
     */
    exists: boolean;
    /**
     * @generated from protobuf field: string registration_token = 2;
     */
    registrationToken: string;
    /**
     * Whether the candidate's account has a password set (password_last_updated is not null).
     *
     * @generated from protobuf field: bool has_password_set = 3;
     */
    hasPasswordSet: boolean;
}
/**
 * Request to reset an account's password (candidate or employee) by nulling out
 * password_last_updated.
 *
 * @generated from protobuf message applied.candidate_experience.ResetAccountPasswordRequest
 */
export interface ResetAccountPasswordRequest {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.ResetAccountPasswordResponse
 */
export interface ResetAccountPasswordResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * Request to get a registration token for an employee by their Anaheim UUID.
 *
 * @generated from protobuf message applied.candidate_experience.EmployeeRegistrationRequest
 */
export interface EmployeeRegistrationRequest {
    /**
     * @generated from protobuf field: string anaheim_uuid = 1;
     */
    anaheimUuid: string;
}
/**
 * Response containing the registration token for an employee.
 *
 * @generated from protobuf message applied.candidate_experience.EmployeeRegistrationResponse
 */
export interface EmployeeRegistrationResponse {
    /**
     * @generated from protobuf field: string registration_token = 1;
     */
    registrationToken: string;
}
/**
 * Request to check if an employee has a user account by their Anaheim UUID.
 *
 * @generated from protobuf message applied.candidate_experience.EmployeeAccountStatusRequest
 */
export interface EmployeeAccountStatusRequest {
    /**
     * @generated from protobuf field: string anaheim_uuid = 1;
     */
    anaheimUuid: string;
}
/**
 * Response containing whether the employee has set a password (password_last_updated is not null).
 *
 * @generated from protobuf message applied.candidate_experience.EmployeeAccountStatusResponse
 */
export interface EmployeeAccountStatusResponse {
    /**
     * @generated from protobuf field: bool has_password_set = 1;
     */
    hasPasswordSet: boolean;
}
/**
 * Response containing employee account status and registration token.
 *
 * @generated from protobuf message applied.candidate_experience.EmployeeCheckResponse
 */
export interface EmployeeCheckResponse {
    /**
     * @generated from protobuf field: bool exists = 1;
     */
    exists: boolean;
    /**
     * @generated from protobuf field: bool has_password_set = 2;
     */
    hasPasswordSet: boolean;
    /**
     * @generated from protobuf field: string registration_token = 3;
     */
    registrationToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Account$Type extends MessageType<Account> {
    constructor() {
        super("applied.candidate_experience.Account", [
            { no: 1, name: "resource_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "profile_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Account>): Account {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceUuid = "";
        message.email = "";
        message.firstName = "";
        message.lastName = "";
        message.profileImageUrl = "";
        if (value !== undefined)
            reflectionMergePartial<Account>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account): Account {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string resource_uuid */ 1:
                    message.resourceUuid = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string first_name */ 3:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 4:
                    message.lastName = reader.string();
                    break;
                case /* string profile_image_url */ 5:
                    message.profileImageUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string resource_uuid = 1; */
        if (message.resourceUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.resourceUuid);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string first_name = 3; */
        if (message.firstName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 4; */
        if (message.lastName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastName);
        /* string profile_image_url = 5; */
        if (message.profileImageUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.profileImageUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.Account
 */
export const Account = new Account$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Candidate$Type extends MessageType<Candidate> {
    constructor() {
        super("applied.candidate_experience.Candidate", [
            { no: 1, name: "account_info", kind: "message", T: () => Account },
            { no: 2, name: "resource_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Candidate>): Candidate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceUuid = "";
        message.applicationId = "";
        if (value !== undefined)
            reflectionMergePartial<Candidate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Candidate): Candidate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* applied.candidate_experience.Account account_info */ 1:
                    message.accountInfo = Account.internalBinaryRead(reader, reader.uint32(), options, message.accountInfo);
                    break;
                case /* string resource_uuid */ 2:
                    message.resourceUuid = reader.string();
                    break;
                case /* string application_id */ 3:
                    message.applicationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Candidate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* applied.candidate_experience.Account account_info = 1; */
        if (message.accountInfo)
            Account.internalBinaryWrite(message.accountInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string resource_uuid = 2; */
        if (message.resourceUuid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceUuid);
        /* string application_id = 3; */
        if (message.applicationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.applicationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.Candidate
 */
export const Candidate = new Candidate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Employee$Type extends MessageType<Employee> {
    constructor() {
        super("applied.candidate_experience.Employee", [
            { no: 1, name: "account_info", kind: "message", T: () => Account },
            { no: 2, name: "resource_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "linkedin_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Employee>): Employee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceUuid = "";
        message.anaheimUuid = "";
        message.linkedinUrl = "";
        if (value !== undefined)
            reflectionMergePartial<Employee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Employee): Employee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* applied.candidate_experience.Account account_info */ 1:
                    message.accountInfo = Account.internalBinaryRead(reader, reader.uint32(), options, message.accountInfo);
                    break;
                case /* string resource_uuid */ 2:
                    message.resourceUuid = reader.string();
                    break;
                case /* string anaheim_uuid */ 3:
                    message.anaheimUuid = reader.string();
                    break;
                case /* string linkedin_url */ 4:
                    message.linkedinUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Employee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* applied.candidate_experience.Account account_info = 1; */
        if (message.accountInfo)
            Account.internalBinaryWrite(message.accountInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string resource_uuid = 2; */
        if (message.resourceUuid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceUuid);
        /* string anaheim_uuid = 3; */
        if (message.anaheimUuid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.anaheimUuid);
        /* string linkedin_url = 4; */
        if (message.linkedinUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.linkedinUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.Employee
 */
export const Employee = new Employee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CandidateSyncRequest$Type extends MessageType<CandidateSyncRequest> {
    constructor() {
        super("applied.candidate_experience.CandidateSyncRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_image_filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CandidateSyncRequest>): CandidateSyncRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.email = "";
        message.firstName = "";
        message.lastName = "";
        message.profileImageFilename = "";
        message.applicationId = "";
        if (value !== undefined)
            reflectionMergePartial<CandidateSyncRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CandidateSyncRequest): CandidateSyncRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string first_name */ 2:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 3:
                    message.lastName = reader.string();
                    break;
                case /* string profile_image_filename */ 4:
                    message.profileImageFilename = reader.string();
                    break;
                case /* string application_id */ 5:
                    message.applicationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CandidateSyncRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string first_name = 2; */
        if (message.firstName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 3; */
        if (message.lastName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lastName);
        /* string profile_image_filename = 4; */
        if (message.profileImageFilename !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.profileImageFilename);
        /* string application_id = 5; */
        if (message.applicationId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.applicationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CandidateSyncRequest
 */
export const CandidateSyncRequest = new CandidateSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CandidateSyncResponse$Type extends MessageType<CandidateSyncResponse> {
    constructor() {
        super("applied.candidate_experience.CandidateSyncResponse", [
            { no: 1, name: "registration_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CandidateSyncResponse>): CandidateSyncResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registrationToken = "";
        if (value !== undefined)
            reflectionMergePartial<CandidateSyncResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CandidateSyncResponse): CandidateSyncResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string registration_token */ 1:
                    message.registrationToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CandidateSyncResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string registration_token = 1; */
        if (message.registrationToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.registrationToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CandidateSyncResponse
 */
export const CandidateSyncResponse = new CandidateSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckCandidateExistsResponse$Type extends MessageType<CheckCandidateExistsResponse> {
    constructor() {
        super("applied.candidate_experience.CheckCandidateExistsResponse", [
            { no: 1, name: "exists", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "registration_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "has_password_set", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckCandidateExistsResponse>): CheckCandidateExistsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exists = false;
        message.registrationToken = "";
        message.hasPasswordSet = false;
        if (value !== undefined)
            reflectionMergePartial<CheckCandidateExistsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckCandidateExistsResponse): CheckCandidateExistsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exists */ 1:
                    message.exists = reader.bool();
                    break;
                case /* string registration_token */ 2:
                    message.registrationToken = reader.string();
                    break;
                case /* bool has_password_set */ 3:
                    message.hasPasswordSet = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckCandidateExistsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exists = 1; */
        if (message.exists !== false)
            writer.tag(1, WireType.Varint).bool(message.exists);
        /* string registration_token = 2; */
        if (message.registrationToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.registrationToken);
        /* bool has_password_set = 3; */
        if (message.hasPasswordSet !== false)
            writer.tag(3, WireType.Varint).bool(message.hasPasswordSet);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CheckCandidateExistsResponse
 */
export const CheckCandidateExistsResponse = new CheckCandidateExistsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetAccountPasswordRequest$Type extends MessageType<ResetAccountPasswordRequest> {
    constructor() {
        super("applied.candidate_experience.ResetAccountPasswordRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetAccountPasswordRequest>): ResetAccountPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial<ResetAccountPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetAccountPasswordRequest): ResetAccountPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetAccountPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.ResetAccountPasswordRequest
 */
export const ResetAccountPasswordRequest = new ResetAccountPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetAccountPasswordResponse$Type extends MessageType<ResetAccountPasswordResponse> {
    constructor() {
        super("applied.candidate_experience.ResetAccountPasswordResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResetAccountPasswordResponse>): ResetAccountPasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial<ResetAccountPasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetAccountPasswordResponse): ResetAccountPasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetAccountPasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.ResetAccountPasswordResponse
 */
export const ResetAccountPasswordResponse = new ResetAccountPasswordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeRegistrationRequest$Type extends MessageType<EmployeeRegistrationRequest> {
    constructor() {
        super("applied.candidate_experience.EmployeeRegistrationRequest", [
            { no: 1, name: "anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeRegistrationRequest>): EmployeeRegistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.anaheimUuid = "";
        if (value !== undefined)
            reflectionMergePartial<EmployeeRegistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeRegistrationRequest): EmployeeRegistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string anaheim_uuid */ 1:
                    message.anaheimUuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeRegistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string anaheim_uuid = 1; */
        if (message.anaheimUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.anaheimUuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeRegistrationRequest
 */
export const EmployeeRegistrationRequest = new EmployeeRegistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeRegistrationResponse$Type extends MessageType<EmployeeRegistrationResponse> {
    constructor() {
        super("applied.candidate_experience.EmployeeRegistrationResponse", [
            { no: 1, name: "registration_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeRegistrationResponse>): EmployeeRegistrationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registrationToken = "";
        if (value !== undefined)
            reflectionMergePartial<EmployeeRegistrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeRegistrationResponse): EmployeeRegistrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string registration_token */ 1:
                    message.registrationToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeRegistrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string registration_token = 1; */
        if (message.registrationToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.registrationToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeRegistrationResponse
 */
export const EmployeeRegistrationResponse = new EmployeeRegistrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeAccountStatusRequest$Type extends MessageType<EmployeeAccountStatusRequest> {
    constructor() {
        super("applied.candidate_experience.EmployeeAccountStatusRequest", [
            { no: 1, name: "anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeAccountStatusRequest>): EmployeeAccountStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.anaheimUuid = "";
        if (value !== undefined)
            reflectionMergePartial<EmployeeAccountStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeAccountStatusRequest): EmployeeAccountStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string anaheim_uuid */ 1:
                    message.anaheimUuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeAccountStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string anaheim_uuid = 1; */
        if (message.anaheimUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.anaheimUuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeAccountStatusRequest
 */
export const EmployeeAccountStatusRequest = new EmployeeAccountStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeAccountStatusResponse$Type extends MessageType<EmployeeAccountStatusResponse> {
    constructor() {
        super("applied.candidate_experience.EmployeeAccountStatusResponse", [
            { no: 1, name: "has_password_set", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeAccountStatusResponse>): EmployeeAccountStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasPasswordSet = false;
        if (value !== undefined)
            reflectionMergePartial<EmployeeAccountStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeAccountStatusResponse): EmployeeAccountStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_password_set */ 1:
                    message.hasPasswordSet = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeAccountStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_password_set = 1; */
        if (message.hasPasswordSet !== false)
            writer.tag(1, WireType.Varint).bool(message.hasPasswordSet);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeAccountStatusResponse
 */
export const EmployeeAccountStatusResponse = new EmployeeAccountStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeCheckResponse$Type extends MessageType<EmployeeCheckResponse> {
    constructor() {
        super("applied.candidate_experience.EmployeeCheckResponse", [
            { no: 1, name: "exists", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "has_password_set", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "registration_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeCheckResponse>): EmployeeCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exists = false;
        message.hasPasswordSet = false;
        message.registrationToken = "";
        if (value !== undefined)
            reflectionMergePartial<EmployeeCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeCheckResponse): EmployeeCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exists */ 1:
                    message.exists = reader.bool();
                    break;
                case /* bool has_password_set */ 2:
                    message.hasPasswordSet = reader.bool();
                    break;
                case /* string registration_token */ 3:
                    message.registrationToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exists = 1; */
        if (message.exists !== false)
            writer.tag(1, WireType.Varint).bool(message.exists);
        /* bool has_password_set = 2; */
        if (message.hasPasswordSet !== false)
            writer.tag(2, WireType.Varint).bool(message.hasPasswordSet);
        /* string registration_token = 3; */
        if (message.registrationToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.registrationToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeCheckResponse
 */
export const EmployeeCheckResponse = new EmployeeCheckResponse$Type();
